import {NgModule} from '@angular/core';
import {APP_CONFIG} from '@app/config/AppConfig';
import {CmsConfig, provideConfig, provideConfigFactory} from '@spartacus/core';
import {SMART_EDIT_FEATURE, SmartEditConfig, SmartEditRootModule} from '@spartacus/smartedit/root';

@NgModule({
  declarations: [],
  imports: [SmartEditRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [SMART_EDIT_FEATURE]: {
          module: () => import('@spartacus/smartedit').then((m) => m.SmartEditModule),
        },
      },
    } as CmsConfig),
    provideConfigFactory((config: SmartEditConfig) => config, [APP_CONFIG]),
  ],
})
export class SmartEditFeatureModule {}
